const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
}).format;

export const formatMoney = (value: number) => formatter(value / 100);
